import React from "react";
import { PageWrapper } from "../../components/modules/wrapper";
import HomeView from "../HomePage/HomeView";

export const HomeContainer = () => {
  return (
    <PageWrapper>
      <HomeView />
    </PageWrapper>
  );
};
